export default HTTPClient => ({
  bulkRead: async (ids = []) => {
    const resp = await HTTPClient.get(`categories/bulk/${ids.join(',')}`);
    return resp;
  },
  readOne: async (id) => {
    const resp = await HTTPClient.get(`categories/${id}`);
    return resp;
  },
  getChildren: async (id) => {
    const resp = await HTTPClient.get(`categories/${id}`);
    return resp.data.items;
  },
  search: async ({
    parent, term, perPage = 20, page = 1,
  }) => {
    const resp = await HTTPClient.get(`categories/${parent}?name=${term}&per_page=${perPage}&page=${page}`);
    return resp;
  },
  searchGraph: async ({
    parent, term, perPage = 20, page = 1,
  }) => {
    const resp = await HTTPClient.get(`categories/${parent}/search?name=${term}&per_page=${perPage}&page=${page}`);
    return resp;
  },
  getAllChildren: async (id) => {
    const resp = await HTTPClient.get(`categories/${id}/children`);
    return resp.data;
  },
});
